import React from 'react';
import { Button } from 'antd';

interface ScheduleWarningConfirmButtonProps {
  onOk: () => void;
  isOptimizing: boolean;
  text: string;
}

const ScheduleWarningConfirmButton: React.FC<ScheduleWarningConfirmButtonProps> = ({ onOk, isOptimizing, text }) => (
  <Button
    key="warning-confirm"
    type="primary"
    onClick={onOk}
    loading={isOptimizing}
    data-cy="confirm-schedule-warning-button"
  >
    {text}
  </Button>
);

export default ScheduleWarningConfirmButton;
